import { SpotData } from "@swivl-mono/types";
import { BrandThemeProvider } from "../BrandTheme/BrandTheme";
import { SpotPageHeader } from "./Spot.Components";
import { type ReactNode } from "react";

interface Props {
  data: SpotData;
  children: ReactNode;
  position?: string;
  rounded?: boolean;
}

export function SpotMainLayoutComponent(props: Props) {
  const { data, children, rounded } = props;

  return (
    <BrandThemeProvider brand={data.brand}>
      <div
        id="mainLayout"
        className="swivl-themed fixed top-0 left-0 right-0 bottom-0 flex flex-column justify-center items-stretch"
        style={{ position: props.position ? (props.position as any) : "fixed" }}
      >
        <div className={`relative flex flex-col size-full md:max-w-screen-sm bg-white md:shadow-md overflow-y-auto [&::-webkit-scrollbar]:bg-transparent [&::-webkit-scrollbar]:rounded-md [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-grey-400 [&::-webkit-scrollbar-thumb]:rounded-md ${rounded ? "md:rounded-lg md:mx-auto" : ""}`}>
          <SpotPageHeader {...data} />
          <div className="bg-white z-20 rounded-t-2xl -mt-6 pt-6 relative pb-4 flex-1">
            {children}
            <div className="z-50 bottom-20 left-0 right-0 p-3 justify-center text-center text-xs text-[#818181]">
              Powered by{" "}
              <a
                rel="noreferrer"
                className="underline text-[#818181]"
                href="https://www.tryswivl.com/?utm_source=spot-location&utm_medium=link-footer&utm_campaign=powered-by-swivl&utm_id=spot"
                target="_blank"
              >
                swivl
              </a>
            </div>
          </div>
        </div>
      </div>
    </BrandThemeProvider>
  );
}
